// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Checkboxes and radio buttons */
.checkbox, .radio {
    accent-color: #7F56D9;
}

.checkbox {
    border-radius: 4px;
}

.checkbox:active, .radio:active {
    accent-color: #7F56D9;
    outline: 5px solid #9E77ED3D;
}

/* Small checkboxes and radio buttons */
.small {
    width: 16px;
    height: 16px;
    border-radius: 4px;
}

/* Large checkboxes and radio buttons */
.large {
    width: 20px;
    height: 20px;
    border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["/* Checkboxes and radio buttons */\n.checkbox, .radio {\n    accent-color: #7F56D9;\n}\n\n.checkbox {\n    border-radius: 4px;\n}\n\n.checkbox:active, .radio:active {\n    accent-color: #7F56D9;\n    outline: 5px solid #9E77ED3D;\n}\n\n/* Small checkboxes and radio buttons */\n.small {\n    width: 16px;\n    height: 16px;\n    border-radius: 4px;\n}\n\n/* Large checkboxes and radio buttons */\n.large {\n    width: 20px;\n    height: 20px;\n    border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
